<template>
  <div class="bg-background-light dark:bg-background-dark text-[#0d121b] dark:text-[#f8f9fc] font-display antialiased">
    <div class="relative flex min-h-screen w-full flex-col overflow-x-hidden group/design-root">
    <AppHeader />
      <main class="flex-1 flex flex-col items-center w-full">
        <div class="w-full max-w-[1280px] flex flex-col">
          <div class="w-full px-4 md:px-8 lg:px-10 py-6 lg:py-8">
            <div class="relative flex min-h-[400px] md:min-h-[480px] flex-col gap-6 rounded-xl items-center justify-center p-8 md:p-12 overflow-hidden">
              <!-- Background Image with dynamic blur effect -->
              <div class="absolute inset-0 bg-cover bg-center bg-no-repeat transition-all duration-1000"
                   :class="imageLoadedMap['banner'] ? 'blur-0 scale-100' : 'blur-2xl scale-110 opacity-50'"
                   style='background-image: linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.7) 100%), url("https://lh3.googleusercontent.com/aida-public/AB6AXuDjVG4SdBlz-yIvAsQN15oAd2M6KH-19Pzjc0ao8TXPgMB7s7t999_wVRcn_9GUWiLMHY_MJU3wqQKZBJpXAjiUf7c4dV7IuwUCAFVvEUQtMTdvpvAYu64oyLUJLrs4AqO9mTC8vhigj--gCUKPPrCO9WbQ5OE7qKYFNYIq3ehldwzylwS8q_ETU_xRkwicCaeqicS7TNu3jvzWO9jwdmf_CzEpA7rfzi4d-VaHGXJssGqu1BnTLj_ZBXRbHvMsxb_6s0pRAQVv4uU");'>
              </div>
              <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuDjVG4SdBlz-yIvAsQN15oAd2M6KH-19Pzjc0ao8TXPgMB7s7t999_wVRcn_9GUWiLMHY_MJU3wqQKZBJpXAjiUf7c4dV7IuwUCAFVvEUQtMTdvpvAYu64oyLUJLrs4AqO9mTC8vhigj--gCUKPPrCO9WbQ5OE7qKYFNYIq3ehldwzylwS8q_ETU_xRkwicCaeqicS7TNu3jvzWO9jwdmf_CzEpA7rfzi4d-VaHGXJssGqu1BnTLj_ZBXRbHvMsxb_6s0pRAQVv4uU" class="hidden" @load="onImageLoad('banner')" />
              <div class="flex flex-col gap-4 text-center max-w-[800px] z-10">
                <h1 class="text-white text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-[-0.033em]">
                  弘扬工匠精神.助推行业发展
                </h1>
                <h2 class="text-gray-200 text-base md:text-lg font-normal leading-relaxed max-w-[640px] mx-auto tracking-widest">
                  服务、团结、互助、自律、进取、奉献
                </h2>
              </div>
              <div class="flex flex-col sm:flex-row gap-4 z-10 w-full sm:w-auto">
                <button @click="openApply" class="flex w-full sm:w-auto cursor-pointer items-center justify-center rounded-lg h-12 px-6 bg-primary hover:bg-blue-700 transition-colors text-white text-base font-bold leading-normal tracking-[0.015em] shadow-lg shadow-blue-900/20">
                  <span class="truncate">立即申请入会</span>
                </button>
              </div>
            </div>
          </div>
          <nav class="w-full px-4 md:px-8 py-4">
            <div class="flex items-center flex-wrap gap-2 text-sm">
              <router-link class="text-gray-500 hover:text-primary dark:text-gray-400 transition-colors" to="/">首页</router-link>
              <span class="material-symbols-outlined text-gray-400 text-[16px]">chevron_right</span>
              <span class="text-[#0d121b] dark:text-white font-medium">会员服务</span>
            </div>
          </nav>
          <section class="w-full px-4 md:px-8 py-8 md:py-12">
            <div class="flex flex-col gap-4 mb-10 text-center md:text-left">
              <h2 class="text-[#0d121b] dark:text-white text-3xl font-bold leading-tight tracking-[-0.015em]">会员服务</h2>
              <p class="text-gray-500 dark:text-gray-400 max-w-[720px] text-lg">助力会员发展，解难会员痛点，赋能会员价值，共创行业辉煌</p>
            </div>

            <!-- 📌 扁平药丸式高级 Tab 导航栏 -->
            <div class="flex border-b border-gray-200 dark:border-gray-700 mb-8 overflow-x-auto hide-scrollbar gap-8">
              <button v-for="tab in serviceTabs" :key="tab.id"
                      @click="activeTab = tab.id"
                      class="pb-4 text-base font-bold transition-all relative whitespace-nowrap"
                      :class="activeTab === tab.id ? 'text-primary border-b-2 border-primary' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200'">
                {{ tab.name }}
              </button>
            </div>

            <!-- 🎯 Tab 1: 会员服务项目 -->
            <div v-if="activeTab === 'service'" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 animate-[fadeIn_0.5s_ease-out]">
                            <div v-for="service in coreServices" :key="service.title"
                                 @click="service.title === '法律援助' && openLegalAid()"
                                 :class="service.title === '法律援助' ? 'cursor-pointer hover:border-primary/40' : ''"
                                 class="bg-white dark:bg-[#1a2230] p-6 rounded-2xl border border-slate-100 dark:border-gray-700 shadow-sm flex flex-col gap-4 hover:shadow-md transition-all duration-300">
                <div class="size-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                  <span class="material-symbols-outlined text-2xl">{{ service.icon }}</span>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-lg font-bold text-slate-800 dark:text-white">{{ service.title }}</h3>
                  <p class="text-sm text-slate-500 dark:text-gray-400 leading-relaxed">{{ service.desc }}</p>
                </div>
              </div>
            </div>

            <!-- 🎯 Tab 2: 协会章程条款 (长卷平铺严肃阅读器) -->
            <div v-else-if="activeTab === 'statute'" class="space-y-6 animate-[fadeIn_0.5s_ease-out]">
              <div class="flex flex-col gap-8 max-w-4xl mx-auto bg-white dark:bg-[#1a2230] p-6 md:p-10 rounded-[2rem] border border-slate-100 dark:border-gray-700 shadow-[0_4px_25px_rgba(0,0,0,0.02)]">
                <!-- 顶部精美标题 -->
                <div class="text-center border-b border-gray-100 dark:border-gray-700 pb-6 mb-6">
                  <h2 class="text-2xl font-black text-slate-800 dark:text-white flex items-center justify-center gap-2">
                    <span class="material-symbols-outlined text-primary text-3xl">gavel</span>
                    湖北省建筑劳务协会章程
                  </h2>
                  <p class="text-xs text-slate-400 font-medium mt-2">（2024年02月29日第二届会员大会表决通过）</p>
                </div>

                <!-- 全篇长卷平铺 -->
                <div class="space-y-8">
                  <div v-for="chap in statuteChapters" :key="chap.title" class="space-y-4">
                    <!-- 章标题 -->
                    <h3 class="text-lg font-black text-slate-800 dark:text-white border-l-4 border-primary pl-3 py-1.5 bg-slate-50/50 dark:bg-gray-800/30 rounded-r">
                      {{ chap.title }}
                    </h3>
                    <!-- 条目列表 -->
                    <ul class="space-y-3 pl-2">
                      <li v-for="(item, itemIdx) in chap.items" :key="itemIdx" class="text-sm text-slate-600 dark:text-gray-300 leading-relaxed text-justify relative pl-4">
                        <span class="absolute left-0 top-2.5 size-1.5 bg-primary/30 rounded-full"></span>
                        <span v-html="renderFormattedItem(item)"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- 🎯 Tab 3: 通知事项 -->
            <div v-else-if="activeTab === 'notice'" class="bg-white dark:bg-[#1a2230] p-6 lg:p-10 rounded-2xl border border-[#e7ebf3] dark:border-gray-700 shadow-sm animate-[fadeIn_0.5s_ease-out]">
              <!-- 通知事项 -->
              <div class="flex flex-col gap-6">
                <h3 class="text-lg font-black text-slate-800 dark:text-white border-l-4 border-primary pl-3 py-1 bg-slate-50/50 dark:bg-gray-800/30 rounded-r flex items-center gap-2">
                  <span class="material-symbols-outlined text-primary text-xl">notifications</span>
                  通知事项
                </h3>
                <ul v-if="notifications.length > 0" class="flex flex-col gap-4">
                  <li v-for="item in notifications" :key="item.id" class="flex flex-col gap-1 p-4 hover:bg-slate-50/50 dark:hover:bg-gray-800/30 rounded-xl transition-colors border border-dashed border-slate-100 dark:border-gray-800">
                    <a :href="getLink(item)" :target="getTarget(item)" class="font-bold text-sm text-slate-700 dark:text-gray-200 hover:text-primary line-clamp-1">
                      {{ item.title }}
                    </a>
                    <div class="flex items-center gap-2 mt-1">
                      <span class="text-xs text-slate-400">{{ formatDate(item.publishTime) }}</span>
                      <ExternalBadge :show="isExternal(item)" />
                    </div>
                  </li>
                </ul>
                <p v-else class="text-xs text-slate-400 text-center py-8">暂无通知事项</p>
              </div>
            </div>
          </section>
          
          <section class="w-full px-4 md:px-8 pb-12">
            <div class="relative overflow-hidden rounded-2xl bg-primary p-8 md:p-12 text-center md:text-left flex flex-col md:flex-row items-center justify-between gap-8">
              <div class="absolute -top-24 -right-24 size-64 rounded-full bg-white/10 blur-3xl"></div>
              <div class="absolute -bottom-24 -left-24 size-64 rounded-full bg-black/10 blur-3xl"></div>
              <div class="relative z-10 flex flex-col gap-4 max-w-[600px]">
                <h2 class="text-white text-2xl md:text-3xl font-black tracking-tight">还不是会员？立即加入我们</h2>
                <p class="text-blue-100 text-lg">欢迎加入湖北省建筑劳务协会，共筑行业发展新格局！</p>
              </div>
              <div class="relative z-10 flex flex-col sm:flex-row gap-4 w-full md:w-auto">
                <button @click="openApply" class="flex items-center justify-center rounded-lg bg-white text-primary px-8 py-3 font-bold text-base hover:bg-gray-100 transition-colors shadow-lg">
                  立即申请入会
                </button>
                <button @click="openMediation" class="flex items-center justify-center rounded-lg border border-white/70 text-white px-8 py-3 font-bold text-base hover:bg-white/10 transition-colors">
                  调解申请
                </button>
                <button @click="openLegalAid" class="flex items-center justify-center rounded-lg border border-white/70 text-white px-8 py-3 font-bold text-base hover:bg-white/10 transition-colors">
                  法律援助
                </button>
                <button @click="openContact" class="flex items-center justify-center rounded-lg border border-white/70 text-white px-8 py-3 font-bold text-base hover:bg-white/10 transition-colors">
                  在线留言
                </button>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footer class="bg-white dark:bg-[#0d121b] border-t border-[#e7ebf3] dark:border-[#2a3441] pt-12 pb-8 px-10">
        <div class="max-w-[1280px] mx-auto w-full">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div class="flex flex-col gap-4">
              <div class="flex items-center gap-2 text-[#0d121b] dark:text-white">
                <img alt="湖北省建筑劳务协会" class="h-8 w-auto object-contain" src="/logo.png"/>
                <span class="text-lg font-bold">湖北省建筑劳务协会</span>
              </div>
              <p class="text-sm text-gray-500 dark:text-gray-400">
                弘扬工匠精神，助推行业发展!<br/>
                ——为建筑劳务保驾护航!
              </p>
            </div>
            <div class="flex flex-col gap-4">
              <h4 class="text-[#0d121b] dark:text-white font-bold">快速链接</h4>
              <div class="flex flex-col gap-2 text-sm text-gray-500 dark:text-gray-400">
                <a class="hover:text-primary" href="https://zjt.hubei.gov.cn/" target="_blank">湖北省住建厅官网</a>
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <h4 class="text-[#0d121b] dark:text-white font-bold">服务支持</h4>
              <div class="flex flex-col gap-2 text-sm text-gray-500 dark:text-gray-400">
                <a class="hover:text-primary" href="#">入会指南</a>
                <a class="hover:text-primary" href="#">表格下载</a>
                <a class="hover:text-primary" href="#">常见问题</a>
                <router-link class="hover:text-primary" to="/contact">联系我们</router-link>
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <h4 class="text-[#0d121b] dark:text-white font-bold">联系方式</h4>
              <div class="flex flex-col gap-3 text-sm text-gray-500 dark:text-gray-400">
                <div class="flex items-start gap-2">
                  <span class="material-symbols-outlined text-base mt-0.5">location_on</span>
                  <span>武汉市汉阳区龙阳大道123号<br/>欧亚达汉阳国际广场A座1803</span>
                </div>
                <div class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-base">call</span>
                  <span>027-84881278 (电话/传真)</span>
                </div>
                <div class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-base">mail</span>
                  <span>hbsjzlwxh@163.com</span>
                </div>
                <div class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-base">markunread_mailbox</span>
                  <span>430000</span>
                </div>
              </div>
            </div>
          </div>
          <div class="border-t border-[#e7ebf3] dark:border-[#2a3441] pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400">
            <p>©2018 湖北省建筑劳务协会保留所有权利。</p>
            <div class="flex items-center gap-4">
              <a class="hover:text-gray-600 dark:hover:text-gray-200" href="#">隐私政策</a>
              <a class="hover:text-gray-600 dark:hover:text-gray-200" href="#">使用条款</a>
              <a class="hover:text-gray-600 dark:hover:text-gray-200" href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备18023234号-1</a>
            </div>
          </div>
        </div>
      </footer>

      <!-- 微信扫码授权弹窗：入会申请须先完成微信授权，再进入 web 端表单页 -->
      <WxQrAuthDialog v-model="showQrAuth" biz="memberApply" @success="onQrAuthSuccess" />
      <!-- 微信扫码授权弹窗：在线留言（与会员申请同款扫码授权） -->
      <WxQrAuthDialog v-model="showQrAuthContact" biz="contact" @success="onContactAuthSuccess" />
      <!-- 微信扫码授权弹窗：调解申请（与会员申请同款扫码授权） -->
      <WxQrAuthDialog v-model="showQrAuthMediation" biz="mediationApply" @success="onMediationAuthSuccess" />
      <!-- 微信扫码授权弹窗：法律援助（与会员申请同款扫码授权） -->
      <WxQrAuthDialog v-model="showQrAuthLegal" biz="legalAid" @success="onLegalAidAuthSuccess" />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import WxQrAuthDialog from '@/components/WxQrAuthDialog.vue';
import newsService from '@/api/newsService';
import dayjs from 'dayjs';

export default {
  name: 'MemberService',
  created() {
    this.fetchData();
  },
  mounted() {
    // 被路由守卫「踢回」本页时自动弹出授权弹窗（见 router 的 apply 身份分支）。
    // ⚠️ 必须按 redirect 判定业务，否则从 /contact、/mediation-apply 被踢回时也会误弹「入会申请」弹窗。
    if (this.$route.query.needAuth === '1') {
      const redirect = String(this.$route.query.redirect || '');
      if (redirect.startsWith('/contact')) {
        this.showQrAuthContact = true;
      } else if (redirect.startsWith('/mediation-apply')) {
        this.showQrAuthMediation = true;
      } else if (redirect.startsWith('/legal-aid')) {
        this.showQrAuthLegal = true;
      } else {
        this.showQrAuth = true;
      }
    }
  },
  components: {
    AppHeader,
    WxQrAuthDialog
  },
  data() {
    return {
      activeTab: 'service',
      serviceTabs: [
        { id: 'service', name: '会员服务项目' },
        { id: 'statute', name: '协会章程条款' },
        { id: 'notice', name: '通知事项' }
      ],
      openChapter: 0,
      notifications: [],
      coreServices: [
        {
          title: '职业培训',
          icon: 'school',
          desc: '获取免费及补贴培训课程，涵盖特种作业、安全生产、技术等级认定等，助您提升职业资格。'
        },
        {
          title: '法律援助',
          icon: 'explore',
          desc: '提供专业的劳动争议咨询、合同纠纷调解及法律援助服务，切实维护职工合法权益。'
        },
        {
          title: '交流活动',
          icon: 'groups',
          desc: '定期举办行业技能比武、经验交流会及文体活动，拓展人脉资源，丰富工业余生活。'
        },
        {
          title: '政策解读',
          icon: 'description',
          desc: '第一时间提供最新行业政策、社保公积金政策的深度解读与办事指南，让您少走弯路。'
        },
        {
          title: '健康安全',
          icon: 'health_and_safety',
          desc: '提供职业健康体检预约、大病互助保障及安全生产教育，守护您的身心健康。'
        },
        {
          title: '困难帮扶',
          icon: 'volunteer_activism',
          desc: '为遭遇突发困难的会员家庭提供临时救助、金秋助学等专项帮扶，传递协会温暖。'
        }
      ],
      statuteChapters: [
        {
          "title": "第一章 总则",
          "items": [
            "第一条 本会名称:湖北省建筑劳务协会(以下简称本会)。",
            "第二条 本会的性质:本会是由湖北省境内依法注册的具有从事建筑劳务的企业、事业单位(具有行政管理职能的事业单位除外)和相关经济组织自愿组成的全省性、行业性、非营利性社会团体。",
            "第三条 本会的宗旨：遵守宪法、法律、法规和国家政策,践行社会主义核心价值观,遵守社会道德风尚。坚持以邓小平理论和“三个代表”重要思想和习近平新时代中国特色社会主义思想作为自己的行动指南，坚持和落实科学发展观、构建和谐社会，坚持党的基本路线，遵守宪法、法律、法规和国家政策。诚信为本，面向社会，面向市场；加强行业自律，规范企业经营行为，在政府和会员企业间发挥桥梁和纽带作用，竭诚为建筑劳务行业和会员企业服务。积极推动企业转换经营机制，建立现代企业制度，促进湖北省建筑劳务行业的健康发展，为加快湖北省的建设作出积极的贡献。",
            "第四条 本会的登记管理机关是湖北省民政厅。业务主管单位是湖北省工商业联合会。本会接受登记管理机关、业务主管单位的业务指导和监督管理。",
            "第五条 本会建立重大事项报告制度。 本会召开理事会、会员大会、大型学术报告会等重要会议，应提前向登记管理机关报告。本会举办庆典、研讨会、论坛等活动，应在每年1月和6月,向登记管理机关申报活动计划，省清理和规范庆典研讨会论坛活动工作领导小组审批通过后方可实施。本会组团出国出境、与境外交流交往，接受境外捐款等,在活动前向政府相关职能部门和登记管理机关报告,需办理手续的,应办理相关手续。",
            "第六条 本会坚持中国共产党的全面领导,根据中国共产党章程的规定,设立中国共产党的组织,开展党的活动,为党组织的活动提供必要条件。",
            "第七条 本会的住所:湖北省武汉市汉阳区龙阳大道123号欧亚达汉阳国际广场A座1803号。"
          ]
        },
        {
          "title": "第二章 业务范围",
          "items": [
            "第八条 本会的业务范围:",
            "（一）研究探讨建筑劳务行业改革和发展的理论、方针、政策以及改革开放中出现的新问题、新情况，向行政主管部门提出有利于行业发展的建议；",
            "（二）开展行业基本情况调查，协助行政主管部门制定和实施行业发展规划和有关法规，推进行业管理，提高全行业的整体素质和经济效益、社会效益；",
            "（三）引导和推动建筑劳务企业面向国内外市场，转变经营机制，发展横向经济联合，推进建筑业科技进步，不断提高工程质量、经营管理水平和企业的竞争能力；",
            "（四）根据会员企业发展的需要，协助会员企业开展技术人才和管理人才的培训，不断提高会员企业整体素质，为会员单位服务；",
            "（五）依法维护会员单位的合法权益，进行法律咨询服务和法律援助行动，反映会员单位的愿望和要求；",
            "（六）组织发展建筑劳务行业的公益事业；",
            "（七）发展同国内外同行业社团组织的友好往来，加快信息交流和推广先进经验，开展业务咨询服务，开展经济技术、经营管理等方面的合作与交流；",
            "（八）积极推广新技术、新材料、新工艺、新规范，提高建筑劳务行业的科技水平；",
            "（九）对行业协会内部会员单位的建筑劳务价格进行指导；",
            "（十）承办政府部门、相关事业单位、社会团体和会员单位委托办理的事项及其他依据法律、法规应办的事项。"
          ]
        },
        {
          "title": "第三章 会员",
          "items": [
            "第九条 本会实行会员制。",
            "第十条 申请加入本会的会员,必须具备下列条件:",
            "(一)拥护本会的章程;",
            "(二)有加入本会的意愿;",
            "(三)在本会的业务(行业)领域内具有一定的影响;",
            "(四)是建筑劳务行业的生产(或销售)企、事业和相关经济组织,以及业务(行业)领域内资深专家。 本会不强制或者变相强制公民、法人或者其他组织加入本会。",
            "第十一条 会员入会的程序是:",
            "(一)提交入会申请书;",
            "(二)经本会理事会讨论通过;",
            "(三)由理事会或理事会授权的机构发给会员证。",
            "第十二条 会员享有下列权利:",
            "(一)本会的选举权、被选举权和表决权;",
            "(二)参加本会的活动;",
            "(三)获得本会服务的优先权;",
            "(四)对本会工作的批评建议权和监督权;",
            "(五)入会自愿、退会自由;",
            "(六)对本会会费收支情况提出质询的权力;",
            "第十三条 会员履行下列义务:",
            "(一)执行本会的决议;",
            "(二)维护本会合法权益;",
            "(三)完成本会交办的工作;",
            "(四)按会员大会(会员代表大会)2/3以上会员(会员代表)无记名投票表决通过的标准缴纳会费;",
            "(五)向本会反映情况，提供有关资料;",
            "(六)积极参与社会公益事业;",
            "第十四条 会员退会应书面通知本会，并交回会员证。会员如果1年不缴纳会费或不参加本会活动的,视为自动退会。",
            "第十五条 会员如有违反法律、法规和本章程的行为,经理事会表决通过,视情节轻重,给予下列处分:",
            "(一)警告;",
            "(二)通报批评;",
            "(三)暂停行使会员权利;",
            "(四)除名。"
          ]
        },
        {
          "title": "第四章 组织机构和负责人产生、罢免",
          "items": [
            "第十六条 本会的最高权力机构是会员大会。会员大会的职权是:",
            "(一)制定和修改章程;",
            "(二)选举和罢免理事、监事，会长、副会长、秘书长;",
            "(三)审议理事会的工作报告和财务报告;",
            "(四)制定和修改会费标准;",
            "(五)决定终止事宜;",
            "(六)决定其他重大事项。",
            "第十七条 会员大会须有2/3以上会员出席方能召开,其决议须经到会会员2/3以上表决通过方能生效。",
            "第十八条 本会每5年召开换届大会。因特殊情况需延期换届的,须由理事会表决通过,报登记管理机关批准。但延期换届最长不超过一年。",
            "第十九条 本会每年应召开一次会员大会。理事会认为有必要或经五分之一以上会员提议的,可以临时召开会员大会。",
            "第二十条 理事会是会员大会的执行机构，在会员大会闭会期间领导本会开展日常工作，对会员大会负责。理事由会员大会选举产生，理事人数不超过会员数的1/3。",
            "第二十一条 理事会的职权是:",
            "(一)执行会员大会的决议;",
            "(二)会员大会闭会期间选举和罢免理事、监事;",
            "(三)筹备召开会员大会;",
            "(四)向会员大会报告工作和财务状况;",
            "(五)决定会员的吸收、除名及奖罚;",
            "(六)决定设立办事机构、分支机构、代表机构和实体机构;",
            "(七)决定副秘书长、各机构主要负责人的聘任;",
            "(八)领导本会各机构开展工作;",
            "(九)制定内部管理制度;",
            "(十)决定其他重大事项。",
            "第二十二条 理事会须有2/3以上理事出席方能召开,其决议须经到会理事2/3以上表决通过方能生效。",
            "第二十三条 1/3以上的理事提议召开理事会的，可以临时召开理事会会议。情况特殊的，经登记管理机关同意后可以通讯形式召开。",
            "第二十四条 本会设会长1人,副会长若干人，秘书长1人。",
            "第二十五条 本会负责人经民主选举程序，通过会员大会以无记名投票方式选举产生。",
            "第二十六条 秘书长为专职,通过选举产生。聘任或者向社会公开招聘的秘书长不是理事，但可以列席理事会会议。",
            "第二十七条 本会换届选举工作由理事会负责,可成立由理事代表、监事代表、党组织代表和会员代表组成的专门选举委员会或选举工作组，负责提名新一届负责人候选人，并组织换届选举工作。",
            "第二十八条 本会负责人候选人的审核把关按省委组织部牵头制定的行业协会商会党建工作实施意见的有关规定执行。党内职务按党的有关规定执行。",
            "第二十九条 本会新一届负责人候选人应当于换届前向全体会员公示,公示期为7天。",
            "第三十条 本会负责人自觉接受党组织和有关方面的监督，会长每年向理事会进行述职。",
            "第三十一条 本会产生新一届负责人后,应当到登记管理机关履行变更手续。",
            "第三十二条 本会会长、副会长、秘书长必须具备下列条件,由选举委员会或选举工作组负责审核:",
            "(一)坚持中国共产党领导，拥护中国特色社会主义，坚决执行党的路线方针政策;",
            "(二)遵纪守法，勤勉尽职，个人社会信用记录良好;",
            "(三)具备相应的专业知识、经验和能力,熟悉业务情况;",
            "(四)身体健康，能正常履责，最高任职年龄为70周岁;",
            "(五)具有完全民事行为能力;",
            "(六)未受过剥夺政治权利的刑事处罚;",
            "(七)没有法律法规禁止任职的其他情形。",
            "第三十三条 会长、秘书长不得兼任其他社会团体会长、秘书长。",
            "第三十四条 会长和秘书长不得由同一人兼任,并不得来自同一会员单位。",
            "第三十五条 本会会长、秘书长每届任期五年,任期与理事会相同，连任不超过2届。因特殊情况需要延长任期的，延长期不得超过一届，且须报业务主管单位或党建工作机构审核同意，经会员(代表)大会2/3以上会员(代表)表决通过，并经登记管理机关批准后方可任职。聘任(含向社会公开招聘)的秘书长连任届次不受限制，可不经过民主选举程序。",
            "第三十六条 本会会长为本会法定代表人。本会法定代表人不兼任其他团体的法定代表人。",
            "第三十七条 本会会长行使下列职权:",
            "(一)召集和主持理事会;",
            "(二)检查会员大会、理事会决议的落实情况;",
            "(三)代表本会签署有关重要文件;",
            "第三十八条 本会秘书长行使下列职权:",
            "(一)主持秘书处日常工作,组织实施年度工作计划;",
            "(二)协调各分支机构、代表机构、实体机构开展工作;",
            "(三)提名副秘书长以及各分支机构、代表机构和实体机构主要负责人,交理事会通过;",
            "(四)决定办事机构、代表机构、实体机构专职工作人员的聘用;",
            "(五)处理其他日常事务。",
            "第三十九条 本会设立监事（监事会）。监事(监事会)由会员大会选举产生。监事人选从本会会员中推荐。监事(监事会)的职权是:",
            "(一)列席理事会，并对决议事项提出质询或建议;",
            "(二)对理事、负责人执行本会职务的行为进行监督，对严重违反本会章程或者会员大会决议的人员提出罢免建议;",
            "(三)检查本会的财务报告，向会员大会报告监事会的工作和提出提案;",
            "(四)对负责人、理事、财务管理人员损害本会利益的行为，要求其及时予以纠正;",
            "(五)向党建工作机构、行业管理部门、登记管理机关以及税务、会计主管部门反映本会工作中存在的问题;",
            "(六)决定其他应由监事会审议的事项; 监事的任期与理事任期相同。监事不得兼任会长、副会长、秘书长、理事及财务管理人员，不得与上述人员有近亲属关系。"
          ]
        },
        {
          "title": "第五章 资产管理、使用原则",
          "items": [
            "第四十条 本会经费来源:",
            "(一)会费;",
            "(二)社会捐赠;",
            "(三)政府资助;",
            "(四)在核准的业务范围内开展服务活动的收入;",
            "(五)利息;",
            "(六)其他合法收入。",
            "第四十一条 本会根据业务工作需要与会员承受能力制定会费标准。本会会费标准的制订和修改经会员大会以无记名投票的方式表决，并获得2/3以上的会员通过后生效。本会会费标准需向社会公开并报告登记管理机关。",
            "第四十二条 本会经费必须用于章程规定的业务范围、事业的发展和保障党支部开展党务活动的经费，不得在会员中分配。",
            "第四十三条 本会建立严格的财务管理制度,保证会计资料合法、真实、准确、完整。",
            "第四十四条 本会配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人员办清交接手续。",
            "第四十五条 本会的资产管理执行国家规定的财务管理制度，接受会员大会和登记管理机关、同级财政部门的监督。资产来源属于国家拨款或者社会捐赠、资助的，必须接受审计机关的监督,并将有关情况以适当方式向社会公布。本会收支情况每年向全体会员公开,会员认为本会违法收费或违法开支的，可向政府有关部门投诉。",
            "第四十六条 本会换届或更换法定代表人之前必须接受登记管理机关组织的财务审计。",
            "第四十七条 本会的资产,任何单位和个人不得侵占、私分和挪用。",
            "第四十八条 本会专职工作人员的工资和保险、福利待遇,参照国家对事业单位的有关规定执行或由理事会决定。本会与聘用人员订立劳动合同，明确双方的权利义务。会员单位派驻协会的工作人员工资、福利待遇由原单位解决，并不得低于在原单位工作时的标准。"
          ]
        },
        {
          "title": "第六章 章程的修改程序",
          "items": [
            "第四十九条 对本会章程的修改，须经理事会表决通过后报会员大会审议。",
            "第五十条 本会修改的章程，须在会员大会通过后，报登记管理机关核准生效。"
          ]
        },
        {
          "title": "第七章 终止程序及终止后的财产处理",
          "items": [
            "第五十一条 本会完成宗旨或自行解散或由于分立、合并等原因需要注销的，由理事会提出终止动议,按下列程序办理:",
            "(一)完成本会宗旨或分立、合并的,经会员大会表决通过。",
            "(二)多数会员退会自行解散的或因其他原因无法召开会员大会的,经理事会表决通过。",
            "第五十五条 本会注销登记前,须在登记管理机关的指导下成立清算组织，清理债权债务，处理善后事宜。清算期间,不开展清算以外的活动。",
            "第五十二条 本会经登记管理机关办理注销登记手续后即为终止。",
            "第五十三条 本会终止后的剩余财产,在登记管理机关的监督下，按照国家有关规定，捐赠给与本会性质、宗旨相近的社会团体继续用于社会公益事业。"
          ]
        },
        {
          "title": "第八章 附则",
          "items": [
            "第五十四条 本章程经2024年 2 月 29日会员大会(会员代表大会)表决通过。",
            "第五十五条 本章程的解释权属本会的理事会。",
            "第五十六条 本章程自登记管理机关核准之日起生效。"
          ]
        }
      ],
      imageLoadedMap: {},
      showQrAuth: false,
      showQrAuthContact: false,
      showQrAuthMediation: false,
      showQrAuthLegal: false
    }
  },
  methods: {
    // ⚠️ 入口不再预扫：表单页允许匿名填写，扫码推迟到「提交/暂存」那一刻（由表单页内弹窗完成）。
    //    下面 4 个 open* 只负责跳转。顺带修掉了旧逻辑的「已授权用户再点入口仍被强制弹一次码」。
    openApply() {
      this.$router.push('/member-apply');
    },
    openContact() {
      this.$router.push('/contact');
    },
    openMediation() {
      this.$router.push('/mediation-apply');
    },
    openLegalAid() {
      this.$router.push('/legal-aid');
    },

    // ↓ 下面 4 个 onXxxAuthSuccess 与模板里的 4 个弹窗**必须保留**：
    //   /member-apply/my、/legal-aid/my、/contact/my 仍受路由守卫保护，
    //   被踢回本页（?needAuth=1&redirect=…）时靠它们弹码并回跳原页。
    onQrAuthSuccess() {
      // 授权态已写入 applyAuth（独立于管理端登录态），回跳原页
      const redirect = this.$route.query.redirect || '/member-apply';
      this.$router.push(redirect);
    },
    onContactAuthSuccess() {
      const redirect = this.$route.query.redirect || '/contact';
      this.$router.push(redirect);
    },
    onMediationAuthSuccess() {
      const redirect = this.$route.query.redirect || '/mediation-apply';
      this.$router.push(redirect);
    },
    onLegalAidAuthSuccess() {
      const redirect = this.$route.query.redirect || '/legal-aid';
      this.$router.push(redirect);
    },
    async fetchData() {
      try {
        const notifRes = await newsService.getNotifications();
        this.notifications = notifRes.data || notifRes || [];
      } catch (error) {
        console.error('获取通知事项失败:', error);
      }
    },
    formatDate(date) {
      if (!date) return '-';
      return dayjs(date).format('YYYY-MM-DD');
    },
    getLink(item) {
      if (item.linkType === 1 && item.externalUrl) return item.externalUrl;
      if (item.linkUrl) return item.linkUrl;
      const isNews = Object.prototype.hasOwnProperty.call(item, 'categoryId');
      return isNews ? `/news/detail/${item.id}` : `/notification/detail/${item.id}`;
    },
    // 是否跳转站外：外链、原文链接都算（与 getLink 同一套判定）
    isExternal(item) {
      if (!item) return false;
      return (item.linkType === 1 && !!item.externalUrl) || !!item.linkUrl;
    },
    getTarget(item) {
      return this.isExternal(item) ? '_blank' : '_self';
    },
    renderFormattedItem(item) {
      if (!item) return '';
      let formatted = item;
      const articleRegex = /^(第[一二三四五六七八九十百]+条)(\s+)?/;
      if (articleRegex.test(formatted)) {
        formatted = formatted.replace(articleRegex, '<strong class="font-black text-slate-800 dark:text-white">$1</strong>$2');
      }
      return formatted;
    },
    onImageLoad(id) {
      this.imageLoadedMap[id] = true;
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
</style>
